import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import WalkthroughNotAvailableSVG from './svgs/WalkthroughNotAvailableSVG';
import GoingCampingSVG from './svgs/GoingCampingSVG';
import './ErrorPage.scss';

const Forbidden = ({ intl }) => {
  const { formatMessage } = intl;
  return (
    <div className="error-page">
      <div className="slds-illustration slds-illustration_large">
        <WalkthroughNotAvailableSVG />
        <div className="slds-text-longform">
          <h3 className="slds-text-heading_medium">
            {formatMessage({ id: 'Forbidden.title' })}
          </h3>
          <p className="slds-text-body_regular">
            {formatMessage({ id: 'Forbidden.text' })}
          </p>
        </div>
      </div>
    </div>
  );
};

Forbidden.propTypes = {
  intl: intlShape.isRequired
};

const GeneralError = ({ intl }) => {
  const { formatMessage } = intl;
  return (
    <div className="error-page">
      <div className="slds-illustration slds-illustration_large">
        <GoingCampingSVG />
        <div className="slds-text-longform">
          <h3 className="slds-text-heading_medium">
            {formatMessage({ id: 'Error.title' })}
          </h3>
        </div>
      </div>
    </div>
  );
};

GeneralError.propTypes = {
  intl: intlShape.isRequired
};

const ErrorPage = {
  GeneralError: injectIntl(GeneralError),
  Forbidden: injectIntl(Forbidden)
};

export default ErrorPage;
